import React, {useState} from 'react';
import Navbar from "../../../layouts/Navbar";
import NoPic from "../../../assets/images/emptypic.png"
import {useNavigate} from "react-router-dom";
import {FaUserEdit} from "react-icons/fa";
import {IoMdHelpBuoy} from "react-icons/io";
import {BsBuildings, BsChevronCompactLeft, BsEnvelopeOpenHeart, BsInfoCircleFill, BsWallet2} from "react-icons/bs";
import {GoSignIn, GoSignOut} from "react-icons/go";
import {MdRuleFolder} from "react-icons/md";
import {getUserInfo} from "../api/ProfileAPIs";
import Loading from "../../../layouts/Loading";
import {showError} from "../../../utils/toastHelper";
import {IoBookmarks} from "react-icons/io5";
import {BiMapAlt} from "react-icons/bi";
import {FiShoppingBag} from "react-icons/fi";
import {VscGitPullRequestGoToChanges} from "react-icons/vsc";


export default function Profile() {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;
    const [loading, setLoading] = useState(true);
    const [user, setUser] = React.useState([]);
    const [hasToken, setHasToken] = React.useState(false);


    React.useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const data = await getUserInfo();
                setUser(data.data.user);
            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (token) {
            setHasToken(true)
            fetchUserInfo();
        }
        else {
            setLoading(false);
        }

    }, []);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }

    if (loading) return <Loading/>;

    return (
        <React.Fragment>
            <main className="container mt-0 pt-3 mb-5 pb-5" style={{background: '#F7F7FC'}}>
                <div className="row px-3 ">
                    <div className="col-12 rtl profile-header">
                        <div className="card-body pt-4">
                            <div className="row pb-4">
                                <div className="col-3">
                                    <img src={user.avatar ? user.avatar : NoPic}
                                         className="rounded-circle mx-auto d-block" alt={user.last_name} width="70px"
                                         style={{objectFit: 'cover'}}
                                         height="70px"/>
                                </div>
                                <div className="col-9">
                                    {
                                        hasToken ?
                                            <div
                                                className=" fw-bold pt-2 mb-2 text-big-1">{user.first_name} {user.last_name}</div>
                                            :
                                            <div className=" fw-bold pt-2">کاربر میهمان</div>
                                    }
                                    <span className=" super-small-2 ltr pt-3">
                                            {user.username ? user.username.replace('+98', '0') : ''}
                                        </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container profile-list-items pt-1">
                    {
                        !hasToken &&
                        <div className="row mt-4 rtl px-4 menu-list-item " onClick={() => navigate('/login')}>

                            <div className="col-2">
                                <span className='icon-container'>
                                     <GoSignIn className='icon' style={{color: "#FB6F3D", fontSize: "1.2em"}}/>
                                </span>

                            </div>
                            <div className="col-9 text-dark menu-text ">
                                وارد شوید
                            </div>
                            <div className="col-1">
                                <BsChevronCompactLeft/>
                            </div>

                        </div>
                    }
                    {
                        hasToken &&
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={() => navigate('/edit-profile')}>

                            <div className="col-2">
                                <span className='icon-container'>
                                     <FaUserEdit className='icon' style={{color: "#FB6F3D", fontSize: "1.2em"}}/>
                                </span>

                            </div>
                            <div className="col-9 text-dark menu-text ">
                                ویرایش مشخصات
                            </div>
                            <div className="col-1">
                                <BsChevronCompactLeft/>
                            </div>

                        </div>
                    }
                    <div className="row mt-4 rtl px-4 menu-list-item border-bottom-0"
                         onClick={() => navigate('/addresses')}>
                        <div className="col-2">
                                <span className='icon-container'>
                                     <BiMapAlt className='icon' style={{color: "#413DFB", fontSize: "1.2em"}}/>
                                </span>

                        </div>
                        <div className="col-9 text-dark menu-text ">

                                مدیریت آدرس ها
                            </div>
                            <div className="col-1">
                                <BsChevronCompactLeft/>
                            </div>
                        </div>
                    </div>


                    <div className="container profile-list-items pt-1">
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={() => navigate('/orders')}>
                            <div className="col-2">
                                <span className='icon-container'>
                                     <FiShoppingBag className='icon' style={{color: "#369BFF", fontSize: "1.2em"}}/>
                                </span>

                            </div>
                            <div className="col-9 text-dark menu-text ">

                                    تاریخچه سفارش ها
                                </div>
                                <div className="col-1">
                                    <BsChevronCompactLeft/>
                                </div>
                            </div>
                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={() => navigate('/factors')}>
                            <div className="col-2">
                                <span className='icon-container'>
                                     <VscGitPullRequestGoToChanges className='icon' style={{color: "#FB7900", fontSize: "1.2em"}}/>
                                </span>

                            </div>
                            <div className="col-9 text-dark menu-text ">

                                    تاریخچه درخواست های پیش فاکتور
                                </div>
                                <div className="col-1">
                                    <BsChevronCompactLeft/>
                                </div>
                            </div>

                        <div className="row mt-4 rtl px-4 menu-list-item" onClick={() => navigate('/favorites')}>
                            <div className="col-2">
                                <span className='icon-container'>
                                     <IoBookmarks className='icon' style={{color: "#B33DFB", fontSize: "1.2em"}}/>
                                </span>

                            </div>
                            <div className="col-9 text-dark menu-text ">

                                    محصولات نشان شده

                                </div>
                                <div className="col-1">
                                    <BsChevronCompactLeft/>
                                </div>

                            </div>


                        <div className="row mt-4 rtl px-4 menu-list-item b"
                             onClick={() => navigate('/wallet')}>
                            <div className="col-2">
                                <span className='icon-container'>
                                     <BsWallet2 className='icon' style={{color: "#FFAA2A", fontSize: "1.2em"}}/>
                                </span>

                            </div>
                            <div className="col-9 text-dark menu-text ">

                                    کیف پول
                                </div>
                                <div className="col-1">
                                    <BsChevronCompactLeft/>
                                </div>

                            </div>

                        <div className="row mt-4 rtl px-4 menu-list-item border-bottom-0"
                             onClick={() => navigate('/producers')}>
                            <div className="col-2">
                                <span className='icon-container'>
                                     <BsBuildings className='icon' style={{color: "#369BFF", fontSize: "1.2em"}}/>
                                </span>

                            </div>
                            <div className="col-9 text-dark menu-text ">

                                    تولید کنندگان
                                </div>
                                <div className="col-1">
                                    <BsChevronCompactLeft/>
                                </div>

                            </div>

                        </div>


                        <div className="container profile-list-items">


                            <div className="row mt-4 rtl px-4 menu-list-item"
                                 onClick={() => navigate('/contents/درباره-ما')}>
                                <div className="col-2">
                                <span className='icon-container'>
                                     <BsInfoCircleFill className='icon' style={{color: "#FB6D3A", fontSize: "1.2em"}}/>
                                </span>

                                </div>
                                <div className="col-9 text-dark menu-text ">

                                        درباره
                                        &nbsp;
                                        {config.title}
                                    </div>
                                    <div className="col-1">
                                        <BsChevronCompactLeft/>
                                    </div>

                                </div>
                            <div className="row mt-4 rtl px-4 menu-list-item"
                                 onClick={() => navigate('/contact')}>
                                <div className="col-2">
                                <span className='icon-container'>
                                     <IoMdHelpBuoy className='icon' style={{color: "#2AE1E1", fontSize: "1.2em"}}/>
                                </span>

                                </div>
                                <div className="col-9 text-dark menu-text ">

                                        اطلاعات تماس
                                    </div>
                                    <div className="col-1">
                                        <BsChevronCompactLeft/>
                                    </div>

                                </div>
                            <div className="row mt-4 rtl px-4 menu-list-item"
                                 onClick={() => navigate('/contents/قوانین-مقررات')}>
                                <div className="col-2">
                                <span className='icon-container'>
                                     <MdRuleFolder className='icon' style={{color: "#413DFB", fontSize: "1.2em"}}/>
                                </span>

                                </div>
                                <div className="col-9 text-dark menu-text ">

                                        قوانین و مقررات
                                    </div>
                                    <div className="col-1">
                                        <BsChevronCompactLeft/>
                                    </div>

                                </div>

                            <div className="row mt-4 rtl px-4 menu-list-item border-bottom-0"
                                 onClick={() => navigate('/profile/invite-others')}>
                                <div className="col-2">
                                <span className='icon-container'>
                                     <BsEnvelopeOpenHeart className='icon' style={{color: "#369BFF", fontSize: "1.2em"}}/>
                                </span>

                                </div>
                                <div className="col-9 text-dark menu-text ">

                                        دعوت دیگران
                                    </div>
                                    <div className="col-1">
                                        <BsChevronCompactLeft/>
                                    </div>

                                </div>

                            </div>

                            <div className="container profile-list-items pt-1 mb-5">

                                {
                                    hasToken &&
                                    <div className="row mt-4 rtl px-4 menu-list-item border-bottom-0"
                                         onClick={onExitClick}>
                                        <div className="col-2">
                                <span className='icon-container'>
                                     <GoSignOut className='icon' style={{color: "#FB4A59", fontSize: "1.2em"}}/>
                                </span>

                                        </div>
                                        <div className="col-9 text-dark menu-text ">

                                                خروج از حساب کاربری
                                            </div>
                                            <div className="col-1">
                                                <BsChevronCompactLeft/>
                                            </div>

                                        </div>
                                        }


                                        <div className='row mt-4'>
                                            <div className="col-12 text-center text-small-3 fw-bold opacity-50">
                                                <a className='text-muted opacity-75 text-decoration-none'
                                                   rel="noreferrer"
                                                   href={`https://idmt.ir/?external=true&from=${config.title}`}
                                                   target='_blank'>
                                                    Powered By IDMT
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    </main>
                                    <Navbar/>
                                    </React.Fragment>
                                    );

                                }

